import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../../Components/TableHelper";
import { useFormik } from "formik";
import { brandSchema } from "../../../Validation/Validation";
import axiosInstance from "../../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../../Components/Breadcrumb";
import ImageUploadDragAndDrop from "../../../Components/ImageUploadDragAndDrop";

const AddTrustBrand = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    image: editData?.image || "",
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive,
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue, touched } =
    useFormik({
      initialValues: initalvalues,
      validationSchema: brandSchema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const formData = new FormData();

          formData.append("sortOrder", values.sortOrder);
          formData.append("isActive", values.isActive || false);
          if (values.image instanceof File) {
            formData.append("image", values.image);
          }

          const response = editingId ? await axiosInstance.put(`/brand/updatebrand/${editingId}`, formData)
            : await axiosInstance.post("/brand/createbrand", formData);

          if (response.status === 200) {
            toast.success(response.data.message);
            navigator(`/brands`);
          }
        } catch (error) {
          toast.error(error.response?.data?.message);
          return error;
        } finally {
          setLoading(false);
        }
      },
    });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Brands", path: `/brands` },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Brand
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="brand-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className={`border border-dark form-control  `}
                        id="brand-sortOrder"
                        name="sortOrder"
                        placeholder="Enter brand Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="slider-image"
                      label={`Brand Logo`}
                      value={values.image}
                      onChange={(file) => setFieldValue("image", file)}
                      error={errors.image}
                      touched={touched.image}
                    />
                  </div>
                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to={`/brands`}>
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTrustBrand;
